import Countdown from 'react-countdown'
import { StatBar } from '../stats/StatBar'
import { Histogram } from '../stats/Histogram'
import { GameStats } from '../../lib/localStorage'
import { shareStatus } from '../../lib/share'
import { tomorrow } from '../../lib/words'
import { PEARCADE_URL } from '../../constants/strings'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  gameStats: GameStats
  isGameLost: boolean
  isGameWon: boolean
  handleShare: () => void
}

export const StatsModal = ({
  isOpen,
  handleClose,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  handleShare,
}: Props) => {
  if (gameStats.totalGames <= 0) {
    return (
      <BaseModal title="Statistics" isOpen={isOpen} handleClose={handleClose}>
        <StatBar gameStats={gameStats} />
      </BaseModal>
    )
  }
  return (
    <BaseModal title="Statistics" isOpen={isOpen} handleClose={handleClose}>
      <StatBar gameStats={gameStats} />
      <h4 className="text-lg leading-6 font-medium text-gray-900">
        Guess Distribution
      </h4>
      <Histogram gameStats={gameStats} />
      {(isGameLost || isGameWon) && (
        <div className="mt-5 sm:mt-6 columns-2">
          <div>
            <h5>New word in</h5>
            <Countdown
              className="text-lg font-medium text-gray-900"
              date={tomorrow}
              daysInHours={true}
            />
          </div>
          <button
            type="button"
            className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            onClick={() => {
              shareStatus(guesses, isGameLost)
              handleShare()
            }}
          >
            Share
          </button>
        </div>
      )}
      {(isGameLost || isGameWon) && (
        <a
          href={`${PEARCADE_URL}&utm_medium=stats_card`}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 flex items-stretch rounded-lg overflow-hidden border border-gray-200 bg-white hover:bg-gray-50 text-left"
          aria-label="Race a friend: Malay Wordle for two on Pearcade"
        >
          <div className="flex-1 min-w-0 px-3 py-2.5 flex flex-col justify-center">
            <div className="text-sm font-bold text-gray-900">Race a friend</div>
            <div className="text-xs text-gray-500 leading-snug">
              Same word, in Malay. Fewer guesses wins.
            </div>
            <div className="flex items-center gap-1.5 mt-1.5 text-xs font-semibold text-gray-900">
              <img src="/images/pearcade-pear.webp" alt="" className="h-4 w-auto" />
              Play on Pearcade <span aria-hidden="true">→</span>
            </div>
          </div>
          <img
            src="/images/pearcade-five.webp"
            alt=""
            loading="lazy"
            className="w-[42%] object-cover"
          />
        </a>
      )}
    </BaseModal>
  )
}
